import { createBrowserHistory } from 'history';

const HISTORY = createBrowserHistory();

HISTORY.listen(({ action }) => {
  // Default to scrolling to the top of the page, if we're not popping off the history stack
  if (action !== 'POP') {
    window.scrollTo(0, 0);
  }
});

export { HISTORY };
